import Vuex from "vuex";
import Vue from "vue";
import userState from "./modules/userControl";
import treeViewState from "./modules/treeViewControl";
import KPIState from "./modules/kpiControl";
import alarmState from "./modules/alarmControl";


Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        userState,
        treeViewState,
        KPIState,
        alarmState
    }
});